$(document).ready(function(){
  var scroll_top = $(window).scrollTop();
  if(scroll_top > 0) {
    $('.index_overlay').removeClass('is-light');
  }
  else {
    $('.index_overlay').addClass('is-light');
  }
  $(window).scroll(function() {
    var scroll_top = $(window).scrollTop();
    if(scroll_top > 0) {
      $('.index_overlay').removeClass('is-light');
    }
    else {
      $('.index_overlay').addClass('is-light');
    }
  });
  $('.header__icon--menu').click(function() {
    if($('.section-header').hasClass('menu-open')) {
      $('.index_overlay').removeClass('is-light');
    }
    else {
      var scroll_top = $(window).scrollTop();
      if(scroll_top > 0) {

      }
      else {
        $('.index_overlay').addClass('is-light');
      }
    }
  });
  $('.sticky_contact_header').click(function() {
    if($('.sticky-contact').hasClass('active')) {
      $('.sticky-contact').removeClass('active');
    }
    else {
      $('.sticky-contact').addClass('active');
    }
    $('.segment-info').removeClass('active');
  });
  $('.open-btn ').click(function() {
    var video_url = $(this).data('video');
    $('.video-content').append(`<video playsinline="playsinline" autoplay="autoplay" loop="loop" controls="controls" preload="metadata"><source src="${video_url}" type="video/mp4"></video>`);
    $('html').addClass('mm-open');
    $('.popup-wrapper video').trigger('play');
  });
  $('.contact-watch ').click(function() {
    var video_url = $(this).data('video');
    $('.video-content').append(`<video playsinline="playsinline" autoplay="autoplay" loop="loop" controls="controls" preload="metadata"><source src="${video_url}" type="video/mp4"></video>`);
    $('html').addClass('mm-open');
    $('.popup-wrapper video').trigger('play');
  });
  $('.close-btn').click(function () {
    $('html').removeClass('mm-open');
    $('.video-content').empty();
  });
  $('.popup_bg').click(function () {
    $('html').removeClass('mm-open');
    $('.video-content').empty();
  });
  $('.acc-available .acc-header').click(function(){
    if($(this).parent().hasClass('active')) {
      $(this).parent().removeClass('active');
    }
    else {
      $(this).parent().addClass('active');
    }
  });
  $('.advanced-header').click(function() {
    var advanced_title = $(this).parents('.section-advanced-acc').data('advanced_title');
    if($("div[data-advanced_title='"+ advanced_title + "']").hasClass('active')){
      $("div[data-advanced_title='"+ advanced_title + "']").removeClass('active');
    }
    else {
      $("div[data-advanced_title='"+ advanced_title + "']").addClass('active');
    }
    if($(this).parent('.advanced-acc').hasClass('active')) {
      $(this).parent('.advanced-acc').removeClass('active');
    }
    else{
      $(this).parent('.advanced-acc').addClass('active');
    }
  });
  $('.simple-variant_item').click(function(e) {
     e.preventDefault();
    $(this).parent().find('.simple-variant_item').removeClass('active');
    $(this).addClass('active');
    var title = $(this).parents('.custom-simple_variant').find('.acc-title').text().trim();
    var subtitle = $(this).find('.custom-variant_title').text().trim();
    $("input[name='properties\\[" + title + "\\]'][value='" + subtitle + "'] + label").click();
    $(".segment-item[data-title='"+ title +"'] .item-value").text(subtitle);
  });
  $('.radio-variant_item').click(function() {
    $(this).parent().find('.radio-variant_item').removeClass('active');
    $(this).addClass('active');
    var title = $(this).parents('.custom-radio_variant').find('.acc-title').text().trim();
    var subtitle = $(this).find('.radio-variant_title').text().trim();
    $("input[name='properties\\[" + title + "\\]'][value='" + subtitle + "']").click();
    $(".segment-item[data-title='"+ title +"'] .item-value").text(subtitle);
  });
  $('.advanced-variant_item').click(function() {
    $(this).parents('.custom-advanced').find('.advanced-variant_item').removeClass('active');
    $(this).addClass('active');
    var title = $(this).parents('.custom-advanced_variant').find('.acc-title').text().trim();
    var subtitle = $(this).find('.custom-variant_title').text().trim();
    $("input[name='properties\\[" + title + "\\]'][value='" + subtitle + "'] + label").click();
    $(".segment-item[data-title='"+ title +"'] .item-value").text(subtitle);
  });
  $('.advanced-simple-variant_item').click(function() {
    $(this).parents('.advanced-simple-variant_list').find('.advanced-simple-variant_item').removeClass('active');
    $(this).addClass('active');
    var title = $(this).parents('.custom-advanced-simple_variant').find('.acc-title').text().trim();
    var subtitle = $(this).find('.custom-variant_title').text().trim();
    $("input[name='properties\\[" + title + "\\]'][value='" + subtitle + "'] + label").click();
    $(".segment-item[data-title='"+ title +"'] .item-value").text(subtitle);
  });
  $(".custom-text_input input").on("input", function(){
    var title = $(this).parents('.custom-option').find('.acc-title').text().trim();
    if($(this).parents('.custom-text').hasClass('custom_qty')){
      console.log('dfd');
      $('.quantity__input').val(Math.ceil($(this).val()));
    }
    $("input[name='properties\\[" + title + "\\]']").val($(this).val());
    $(".segment-item[data-title='"+ title +"'] .item-value").text($(this).val());
  });
  $('.segment-header').click(function() {
    if($('.segment-info').hasClass('active')) {
      $('.segment-info').removeClass('active');
    }
    else {
      $('.segment-info').addClass('active');
    }
    $('.sticky-contact').removeClass('active');
  });
  // setTimeout(function(){$('.bcpo').removeAttr('id');},500);
  
  $('.upload_btn').click(function() {
    $("input[name='properties[File Upload]']").click();
    if( document.querySelector("input[name='properties[File Upload]']").files.length == 0 ){
    console.log("no files selected");
    }
  });
  $('body').on('click','.bcpo-modal-parent .bcpo-modal-close-link', function() {
    location.reload(true);
  });

  var modal = document.querySelector('.bcpo-modal-parent');

  // document.addEventListener("click", (evt) => {
  //   const flyoutElement = document.querySelector(".bcpo-modal");
  //   let targetElement = evt.target; // clicked element

  //   do {
  //       if (targetElement == flyoutElement) {
  //           return;
  //       }
  //       // Go up the DOM.
  //       targetElement = targetElement.parentNode;
  //   } while (targetElement);

  //   // Do something useful here.
    
    
  // });
  //  window.addEventListener('mouseup',function(event){
  //       var pol = document.querySelector(".bcpo-modal");
  //       if(event.target != pol && event.target.parentNode != pol){
  //           location.reload(true);
  //       }
  // }); 
  $('body').on('click','.custom-pdp_btn', function() {
    var qty = $('.custom_qty input').val();
    if (!$.isNumeric(qty)) {
      alert('The minimum segment length in feet requirement is: 4');
    }
    else {
      if(parseInt(qty) < 4) {
          alert('The minimum segment length in feet requirement is: 4');
      }
      else {
        $('.product-form__buttons button:first-child').click();
      }
    }
  });
});